import { TextNode, } from "lexical";
export class MentionNode extends TextNode {
    __id;
    static getType() {
        return "mention";
    }
    static clone(node) {
        return new MentionNode(node.__id, node.getTextContent(), node.__key);
    }
    constructor(id, text, key) {
        super(text, key);
        this.__id = id;
    }
    createDOM(config) {
        const dom = super.createDOM(config);
        dom.classList.add("rounded", "bg-blue-100", "px-1.5", "py-0.5", "text-sm", "font-semibold", "text-blue-700");
        dom.dataset.mentionId = this.__id;
        dom.setAttribute("role", "link");
        dom.setAttribute("tabIndex", "0");
        return dom;
    }
    static importJSON(serializedNode) {
        return $createMentionNode(serializedNode.id, serializedNode.text);
    }
    exportJSON() {
        const serialized = super.exportJSON();
        return {
            ...serialized,
            id: this.__id,
            type: "mention",
            version: 1,
        };
    }
}
export function $createMentionNode(id, name) {
    const mentionNode = new MentionNode(id, name.startsWith("@") ? name : `@${name}`);
    mentionNode.setMode("segmented");
    mentionNode.setDetail(0);
    return mentionNode;
}
export function $isMentionNode(node) {
    return node instanceof MentionNode;
}
